import { MicrositeTemplate } from '~/model';
import { type ComponentConfig } from '@puckeditor/core';
import { DEMO_PROFILES } from '~/demo';
import { useRegisterSection } from '~/hooks/useSections';
import ProfileBlockAlpha from '~/editor/templates/alpha/ProfileBlockAlpha';
import ProfileBlockDelta from '~/editor/templates/delta/ProfileBlockDelta';
import ProfileBlockEpsilon from '~/editor/templates/epsilon/ProfileBlockEpsilon';
import ProfileBlockEta from '~/editor/templates/eta/ProfileBlockEta';
import ProfileBlockZeta from '~/editor/templates/zeta/ProfileBlockZeta';
import ProfileBlockBeta from '~/editor/templates/beta/ProfileBlockBeta';

export interface MatterportBlockProps {
	navigation?: boolean;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_PROFILE: ComponentConfig<MatterportBlockProps> = {
	label: 'Profiles',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <ProfileBlock {...props} />;
	},
};

export default function ProfileBlock({ navigation = true, template }: MatterportBlockProps) {
	const id = useRegisterSection('agents', 'Agents', navigation);

	if (template === MicrositeTemplate.ALPHA) {
		return (
			<div id={id}>
				<ProfileBlockAlpha profiles={DEMO_PROFILES} />
			</div>
		);
	}
	if (template === MicrositeTemplate.BETA) {
		return (
			<div id={id}>
				<ProfileBlockBeta profiles={DEMO_PROFILES} />
			</div>
		);
	}
	if (template === MicrositeTemplate.DELTA) {
		return (
			<div id={id}>
				<ProfileBlockDelta profiles={DEMO_PROFILES} />
			</div>
		);
	}
	if (template === MicrositeTemplate.EPSILON) {
		return (
			<div id={id}>
				<ProfileBlockEpsilon profiles={DEMO_PROFILES} />
			</div>
		);
	}
	if (template === MicrositeTemplate.ETA) {
		return (
			<div id={id}>
				<ProfileBlockEta profiles={DEMO_PROFILES} />
			</div>
		);
	}
	if (template === MicrositeTemplate.ZETA) {
		return (
			<div id={id}>
				<ProfileBlockZeta profiles={DEMO_PROFILES} />
			</div>
		);
	}

	return <></>;
}
